/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPos = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2v4h4v12h-4v4H2V2zm-2 2H4v16h12zM7 17v2H5v-2zm8 0v2h-2v-2zm-4 0v2H9v-2zm9-9h-2v8h2zM7 13v2H5v-2zm8 0v2h-2v-2zm-4 0v2H9v-2zm4-8v6H5V5zm-2 2H7v2h6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPos as Pos };
